/**
 * Editorial empty states. Rendered as HTML strings.
 *
 * Pass a small inline SVG for `icon` (line-art works best with the
 * editorial aesthetic) plus a serif title + warm body copy.
 */
export function emptyState({ icon = '', title, body, action = '', size = 'small' }) {
  const cls = size === 'large' ? 'empty-state large' : 'empty-state';
  return `
    <div class="${cls}">
      ${icon ? `<div class="empty-state-icon">${icon}</div>` : ''}
      <div class="empty-state-title">${escape(title)}</div>
      <div class="empty-state-body">${escape(body)}</div>
      ${action ? `<div class="empty-state-action">${action}</div>` : ''}
    </div>
  `;
}

// ---- Small reusable line-art icons ----

export const ICON_LAYERS = `
<svg viewBox="0 0 48 48"><polygon points="24 6 42 16 24 26 6 16 24 6"/><polyline points="6 24 24 34 42 24"/><polyline points="6 32 24 42 42 32"/></svg>`;

export const ICON_CATALOG = `
<svg viewBox="0 0 48 48"><rect x="6" y="8" width="36" height="32" rx="2"/><line x1="14" y1="8" x2="14" y2="40"/><line x1="22" y1="14" x2="36" y2="14"/><line x1="22" y1="22" x2="36" y2="22"/><line x1="22" y1="30" x2="32" y2="30"/></svg>`;

export const ICON_STORIES = `
<svg viewBox="0 0 48 48"><path d="M12 8h24v32l-12-7-12 7z"/><line x1="18" y1="18" x2="30" y2="18"/><line x1="18" y1="24" x2="26" y2="24"/></svg>`;

export const ICON_PROJECTS = `
<svg viewBox="0 0 48 48"><path d="M6 14l8-6h28v32H6z"/><line x1="6" y1="20" x2="42" y2="20"/></svg>`;

function escape(s) {
  return String(s ?? '').replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
}
